module.exports = __webpack_public_path__ + "static/media/img_14.041bd823.png";